module.exports = __webpack_public_path__ + "static/img/miner-mk-3_256.b0d7706.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/miner-mk-3_256.png
// module id = mEyV
// module chunks = 0